export const organizationResourcesQueryKeys = {
  all: ["organization-resources"] as const,
  competitions: ({ sport, organizationId }: { sport: string; organizationId: string }) =>
    [...organizationResourcesQueryKeys.all, "competitions", sport, organizationId] as const,
  seasons: ({
    sport,
    organizationId,
    competitionIds,
  }: {
    sport: string;
    organizationId: string;
    competitionIds: string[];
  }) => [...organizationResourcesQueryKeys.all, "seasons", sport, organizationId, competitionIds] as const,
  entities: ({
    sport,
    organizationId,
    seasonIds,
  }: {
    sport: string;
    organizationId: string;
    seasonIds: string[];
  }) => [...organizationResourcesQueryKeys.all, "entities", sport, organizationId, seasonIds] as const,
  entitiesByIds: ({
    sport,
    organizationId,
    entityIds,
  }: {
    sport: string;
    organizationId: string;
    entityIds: string[];
  }) => [...organizationResourcesQueryKeys.all, "entities-by-id", sport, organizationId, entityIds] as const,
  venues: ({ sport, organizationId }: { sport: string; organizationId: string }) =>
    [...organizationResourcesQueryKeys.all, "venues", sport, organizationId] as const,
  seasonTeamsTree: ({
    sport,
    organizationId,
    competitionIds,
  }: {
    sport: string;
    organizationId: string;
    competitionIds: string[];
  }) => [...organizationResourcesQueryKeys.all, "season-teams-tree", sport, organizationId, competitionIds] as const,
};
